import BottomNav from './BottomNavContainer';

export default BottomNav;
